import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TID } from "../lib/testIds";
import { useLang } from "../lib/LangContext";
import { useMode } from "../lib/ModeContext";
import { UI } from "../lib/content";

export default function TopNavigation({ onOpenIndex, onExportPdf }) {
    const { lang, setLang } = useLang();
    const { mode, setMode } = useMode();
    const t = UI[lang];

    return (
        <motion.nav
            data-testid={TID.nav}
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 2.6, duration: 0.9, ease: [0.7, 0, 0.2, 1] }}
            className="fixed top-0 left-0 right-0 z-40 no-print"
            style={{ background: "rgba(244,239,230,0.86)", backdropFilter: "blur(10px)" }}
        >
            <div className="flex items-center justify-between px-6 md:px-10 py-4 md:py-5">
                <button
                    onClick={onOpenIndex}
                    data-testid={TID.indexButton}
                    className="font-micro text-[10px] md:text-[11px] link-ed"
                    style={{ color: "#0B0B0B" }}
                    aria-label="Open chapter index"
                >
                    <span className="inline-block w-4 h-px align-middle mr-2" style={{ background: "#0B0B0B" }} />
                    {t.index}
                </button>

                <div className="flex items-center gap-1 font-didone text-lg md:text-xl" style={{ letterSpacing: "0.14em" }}>
                    <span>I</span>
                    <span className="inline-block" style={{ transform: "scaleX(-1)" }}>R</span>
                    <span className="hidden md:inline">·</span>
                    <span className="hidden md:inline font-micro text-[9px] tracking-[0.32em] ml-2 opacity-70">MMXXVII</span>
                </div>

                <div className="flex items-center gap-4 md:gap-6">
                    {/* Mode toggle */}
                    <div
                        data-testid={TID.modeToggle}
                        className="hidden md:flex items-center gap-3 font-micro text-[10px]"
                    >
                        <button
                            data-testid="mode-scroll"
                            onClick={() => setMode("scroll")}
                            className={`link-ed ${mode === "scroll" ? "" : "opacity-40"}`}
                        >
                            {t.read}
                        </button>
                        <span className="w-3 h-px" style={{ background: "#C9A96A" }} />
                        <button
                            data-testid="mode-flipbook"
                            onClick={() => setMode("flipbook")}
                            className={`link-ed ${mode === "flipbook" ? "" : "opacity-40"}`}
                        >
                            {t.presentation}
                        </button>
                    </div>

                    {/* Lang toggle */}
                    <div data-testid={TID.langToggle} className="flex items-center gap-2 font-micro text-[10px]">
                        <button
                            data-testid="lang-en"
                            onClick={() => setLang("en")}
                            className={`link-ed ${lang === "en" ? "" : "opacity-40"}`}
                        >
                            EN
                        </button>
                        <span className="opacity-40">·</span>
                        <button
                            data-testid="lang-it"
                            onClick={() => setLang("it")}
                            className={`link-ed ${lang === "it" ? "" : "opacity-40"}`}
                        >
                            IT
                        </button>
                    </div>

                    <button
                        onClick={onExportPdf}
                        data-testid={TID.pdfButton}
                        className="font-micro text-[10px] link-ed hidden md:inline"
                        aria-label="Export PDF"
                    >
                        PDF
                    </button>
                </div>
            </div>
            <div className="h-px w-full" style={{ background: "#C9A96A", opacity: 0.4 }} />
        </motion.nav>
    );
}
